<div class="col-xl">
    <div class="card mb-4">
        <div class="card-body">

            <div class="row">
                <div class="col">
                    <div class="input-group input-group-merge">
                        <label class="switch switch-lg">
                            <input type="checkbox" id="updateAccountStatus" class="switch-input" (change)="updateDonutChart()" />
                            <span class="switch-toggle-slider">
                                <span class="switch-on">
                                    <i class="ti ti-check"></i>
                                </span>
                                <span class="switch-off">
                                    <i class="ti ti-x"></i>
                                </span>
                            </span>
                            <span class="switch-label">Visualizar datos en porcentajes</span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="row" *ngIf="!loading">
                <!-- Columna izquierda (1/3) -->
                <div class="col d-flex flex-column column-left">
                    <div class="card mt-3" style="background-color: #d3f1ef">
                        <div class="card-body m-0 p-1" >
                            <h5 class="mb-0 fw-bold"><i class="ti ti-menu-2"></i>&nbsp;Total de servicios</h5>
                            <div class="big-number">{{ stats.total_services }}</div>
                            <div class="sub mt-1">
                                <div class="row">
                                    <div class="col">
                                        En proceso: <span class="color-ok aria-font">{{ getFormattedValue(stats.in_process, stats.total_services) }}{{displayPercentages ? '%' : ''}}</span>
                                    </div>
                                    <div class="col">
                                        Finalizados: <span class="color-success aria-font">{{ getFormattedValue(stats.finished, stats.total_services) }}{{displayPercentages ? '%' : ''}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3 border-card">
                        <div class="card-body m-0 p-1">
                            <h5 class="mb-0 fw-bold"><i class="ti ti-clock-check"></i>&nbsp;Total servicios puntuales</h5>
                            <div class="big-number color-success">{{ getFormattedValue(stats.punctual_services_pct, stats.total_services) }}{{displayPercentages ? '%' : ''}}</div>
                        </div>
                    </div>
                    <div class="card mt-3 border-card">
                        <div class="card-body m-0 p-1">
                            <h5 class="mb-0 fw-bold"><i class="ti ti-clock-x"></i>&nbsp;Total servicios con retraso</h5>
                            <div class="big-number color-ok">{{ getFormattedValue(stats.delayed_services_pct, stats.total_services) }}{{displayPercentages ? '%' : ''}}</div>
                            <div class="sub mt-1">
                                <div class="row">
                                    <div class="col">
                                        Tarde: <span class="color-delay aria-font">{{ getFormattedValue(stats.late_services_pct, stats.delayed_services_pct) }}{{displayPercentages ? '%' : ''}}</span>
                                    </div>
                                    <div class="col">
                                        Muy tarde: <span class="color-danger aria-font">{{ getFormattedValue(stats.very_late_services_pct, stats.delayed_services_pct) }}{{displayPercentages ? '%' : ''}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Centro (2/3 = col-md-8)-->
                <div class="col">
                    <div class="col d-flex flex-column">
                        <div class="card mt-3 border-card" style="height: 12.5rem;">
                            <div class="card-body m-0 p-1">
                                <h5 class="mb-1 fw-bold d-block"><i class="ti ti-file-analytics"></i>&nbsp;Total servicios</h5>
                                <div class="chart-container" style="height:83%; position: relative;">
                                    <canvas #pieChartCanvas style="width: 100%; height: 100%;"></canvas>
                                </div>
                            </div>
                        </div>
                        <div class="card mt-3 border-card" style="height: 12.5rem;">
                            <div class="card-body m-0 p-1">
                                <h5 class="mb-1 fw-bold d-block"><i class="ti ti-file-analytics"></i>&nbsp;Puntualidad</h5>
                                <div class="chart-container" style="height:83%; position: relative;">
                                    <canvas #donutChartCanvas style="width: 100%; height: 100%;"></canvas>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col d-flex flex-column column-right">
                    <div class="card mt-3" style="background-color: #d3f1ef">
                        <div class="card-body m-0 p-1">
                            <h5 class="mb-0 fw-bold"><i class="ti ti-shredder"></i>&nbsp;Cargas puntuales</h5>
                            <div class="big-number">{{ getFormattedValue(stats.punctual_loads, stats.total_services) }}{{displayPercentages ? '%' : ''}}</div>
                            <div class="sub mt-1">
                                <div class="row">
                                    <div class="col">
                                        Tarde: <span class="color-ok aria-font">{{ getFormattedValue(stats.late_loads, stats.punctual_loads) }}{{displayPercentages ? '%' : ''}}</span></div>
                                    <div class="col">Muy tarde: <span class="color-success aria-font">{{ getFormattedValue(stats.very_late_loads, stats.punctual_loads) }}{{displayPercentages ? '%' : ''}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3 border-card">
                        <div class="card-body m-0 p-1">
                            <h5 class="mb-0 fw-bold"><i class="ti ti-file-download"></i>&nbsp;Descargas puntuales</h5>
                            <div class="big-number color-ok">{{ getFormattedValue(stats.punctual_downloads, stats.total_services) }}{{displayPercentages ? '%' : ''}}</div>
                            <div class="sub mt-1">
                                <div class="row">
                                    <div class="col">
                                        Tarde: <span class="color-delay aria-font">{{ getFormattedValue(stats.late_downloads, stats.punctual_downloads) }}{{displayPercentages ? '%' : ''}}</span></div>
                                    <div class="col">Muy tarde: <span class="color-danger aria-font">{{ getFormattedValue(stats.very_late_downloads, stats.punctual_downloads) }}{{displayPercentages ? '%' : ''}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mt-3 border-card">
                        <div class="card-body m-0 p-1">
                            <h5 class="mb-0 fw-bold"><i class="ti ti-truck"></i>&nbsp;Salida de patio puntuales</h5>
                            <div class="big-number color-ok">{{ stats.patio_exit_punctuality }}</div>
                            <div class="sub mt-1">
                                <div class="row">
                                    <div class="col">
                                        Tarde: <span class="color-delay aria-font">{{ getFormattedValue(stats.patio_exit_delay, stats.patio_exit_punctuality) }}{{displayPercentages ? '%' : ''}}</span></div>
                                    <div class="col">Muy tarde: <span class="color-success aria-font">{{ getFormattedValue(stats.patio_exit_very_delay, stats.patio_exit_punctuality) }}{{displayPercentages ? '%' : ''}}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>